import { flowUtils } from '@atlassian/mpac-utils';
export const foldLicenseType = a => (evaluation, subscription) => {
  switch (a.type) {
    case 'evaluation':
      return evaluation(a);
    case 'subscription':
      return subscription(a);
    default:
      throw flowUtils.unexpectedCase(a);
  }
};